/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {AppProjectsOilSchemasSchemasBlendOut} from './AppProjectsOilSchemasSchemasBlendOut';
import {
  AppProjectsOilSchemasSchemasBlendOutFromJSON,
  AppProjectsOilSchemasSchemasBlendOutFromJSONTyped,
  AppProjectsOilSchemasSchemasBlendOutToJSON
} from './AppProjectsOilSchemasSchemasBlendOut';

/**
 *
 * @export
 * @interface BlendsOut
 */
export interface BlendsOut {
  /**
   *
   * @type {Array<AppProjectsOilSchemasSchemasBlendOut>}
   * @memberof BlendsOut
   */
  blends: Array<AppProjectsOilSchemasSchemasBlendOut>;
}

/**
 * Check if a given object implements the BlendsOut interface.
 */
export function instanceOfBlendsOut(value: object): value is BlendsOut {
  if (!('blends' in value) || value['blends'] === undefined) return false;
  return true;
}

export function BlendsOutFromJSON(json: any): BlendsOut {
  return BlendsOutFromJSONTyped(json, false);
}

export function BlendsOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlendsOut {
  if (json == null) {
    return json;
  }
  return {
    blends: (json['blends'] as Array<any>).map(AppProjectsOilSchemasSchemasBlendOutFromJSON)
  };
}

export function BlendsOutToJSON(value?: BlendsOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    blends: (value['blends'] as Array<any>).map(AppProjectsOilSchemasSchemasBlendOutToJSON)
  };
}
